import { Component, OnInit } from '@angular/core';
import * as CoreActions from '@app/core/store/core.action';
import { ActivatedRoute } from "@angular/router";
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {

  constructor( private store$: Store, public route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.store$.dispatch(CoreActions.setTitle({ title: this.route.snapshot.data['title'] }));

  }

}
